var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-46",
    "data-name": "50_Kids_Icons-46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M152.947,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S151.922,244.065,152.947,246.493Z",
    transform: "translate(-123.38 -204.934)",
    fill: "#e68c6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M320,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S321.025,244.065,320,246.492Z",
    transform: "translate(-269.567 -204.934)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M128.4,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-59.397 -326.964)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M226.979,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-180.384 -214.962)",
    fill: "#e68c6f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958",
    transform: "translate(26.617 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M197.113,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923a10.422,10.422,0,0,1-10.422-10.422V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-170.346 -115.884)",
    fill: "#f5b29c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(33.321 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(43.584 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M244.43,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,244.43,279.542Z",
    transform: "translate(-202.216 -235.864)",
    fill: "#f59576"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M128.39,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-59.398 -339.904)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M188.918,126.619l-.354-5.538a19.081,19.081,0,0,0,.291-3.309c0-9.405-6.8-17.029-15.182-17.029s-15.182,7.624-15.182,17.029a19.077,19.077,0,0,0,.291,3.309l-.354,5.538,2.367-.073.678-8.3.019-.168a5.61,5.61,0,0,1,5.574-4.975h13.215a5.61,5.61,0,0,1,5.574,4.974l.024.21.675,8.264Z",
    transform: "translate(-133.672 -85.002)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(33.941 47.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M226.959,306.564c-1.751,2.825-6.743,2.833-8.5.016-.448-.714-1.58-.056-1.13.664,2.288,3.661,8.491,3.65,10.768-.02.446-.72-.689-1.374-1.133-.66Z",
    transform: "translate(-217.221 -306.255)",
    fill: "#cf4d3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M157.263,109.884c-8.063-2.906-15.968-1.88-18.694,2.181a23.778,23.778,0,0,0,10.937,7.525c8.063,2.906,15.968,1.88,18.694-2.181A23.778,23.778,0,0,0,157.263,109.884Z",
    transform: "translate(-116.918 -91.315)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M225.625,86.072a20.15,20.15,0,0,0-2.077-3.672c-3.924-5.508-9.705-7.857-13.548-5.75a18.2,18.2,0,0,0,3.536,10.291,19.03,19.03,0,0,0,2.649,3.006A59.472,59.472,0,0,0,225.625,86.072Z",
    transform: "translate(-177.187 -64.027)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968",
    transform: "translate(31.162 35.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M200.622,228.494a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.323,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-199.434 -226.384)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969",
    transform: "translate(42.901 35.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M279.131,227.524a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-274.565 -226.383)",
    fill: "#fceeb3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar9);
export default __webpack_public_path__ + "static/media/avatar9.c3bcabe212f296cb07cab4df4e7a645e.svg";
export { ForwardRef as ReactComponent };